export default () => ({
	overflow: false,
	resetState: false,
	forceNavigation: false,
	bypassEnforcer: false,
	showFooter: true,
	leavingModal: false,
	showBackButton: true,
	allowGlia: true
});
